import React, { useState, useEffect, useRef } from "react";
import { MoreVertical, Pencil, Trash2, UserPlus } from "lucide-react";

const DropdownActions = ({
  onEdit,
  onDelete,
  onInvite,
  type,
  showEdit = true,
  showDelete = true,
  showInvite = true,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleToggle = (e) => {
    e.stopPropagation();
    setOpen(!open);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit();
    setOpen(false);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete();
    setOpen(false);
  };

  const handleInvite = (e) => {
    e.stopPropagation();
    onInvite && onInvite();
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    // <div
    //   className="dropdown-container"
    //   onClick={(e) => e.stopPropagation()}
    //   ref={dropdownRef}
    // >
    //   <button className="dots-btn" onClick={handleToggle}>
    //     <MoreVertical size={18} />
    //   </button>
    //   {open && (
    //     <div className="dropdown-menu">
    //       {showEdit && onEdit && (
    //         <button className="dropdown-item" onClick={handleEdit}>
    //           <Pencil size={14} /> Edit
    //         </button>
    //       )}
    //       {showDelete && onDelete && (
    //         <button className="dropdown-item delete" onClick={handleDelete}>
    //           <Trash2 size={14} /> Delete
    //         </button>
    //       )}

    //       {showInvite && type === "publication" && onInvite && (
    //         <button className="dropdown-item" onClick={handleInvite}>
    //           <UserPlus size={14} /> Invite Collaborator
    //         </button>
    //       )}
    //     </div>
    //   )}
    // </div>
   <div
  ref={dropdownRef}
  onClick={(e) => e.stopPropagation()}
  className="w-full relative"
>
  <button
    onClick={handleToggle}
    className="absolute top-[30px] right-0 w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
  >
    <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
    </svg>
  </button>

  {open && (
    <div className="absolute right-0 top-full mt-1 z-10 bg-white rounded-xl shadow-lg border border-gray-200 py-1 min-w-[160px]">
      {showEdit && onEdit && (
        <button
          onClick={handleEdit}
          className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          Edit
        </button>
      )}

      {showDelete && onDelete && (
        <button
          onClick={handleDelete}
          className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-red-500 hover:bg-red-50 transition-colors"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
          Delete
        </button>
      )}

      {showInvite && type === "publication" && onInvite && (
        <button
          onClick={handleInvite}
          className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
          </svg>
          Invite Collaborator
        </button>
      )}
    </div>
  )}
</div>

  );
};

export default DropdownActions;
